import { render, staticRenderFns } from "./PhoneNumberForm.vue?vue&type=template&id=5f595cca&scoped=true&"
import script from "./PhoneNumberForm.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberForm.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberForm.vue?vue&type=style&index=0&id=5f595cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f595cca",
  null
  
)

export default component.exports